//import React from 'react';

function IfComponent({ condicional, children }) {
    return (condicional ? children : null);
}

export default IfComponent;